import {
    Box,
    Button,
    Grid,
    Typography,
    TextField,
    Stack,
    Paper,
    Autocomplete,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import VehicleExploreSection from '../components/VehicleExploreSection';
import BannerSection from "../components/BannerSection";
import CommercialArticlesSection, { ArticleData } from '../components/CommercialArticlesSection'; // Import interface if available
import axiosInstance from '../services/axiosInstance';
import { enqueueSnackbar } from 'notistack';
import Footer from '../components/Footer';

const ArticlePage = () => {
    const navigate = useNavigate();

    // State
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [adSpaceBanner, setAdSpaceBanner] = useState<any[]>([]);

    // Fixed typo: artcileList -> articleList
    const [articleList, setArticleList] = useState<ArticleData[]>([]);

    // 1. Fetch Ads AND Articles
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.post(
                    "/CustomerVehicle/VehicleMultipleDataList",
                    {
                        adSpaceData: true,
                        articleData: true // <--- Request Article Data Here
                    },
                    { headers: { "Content-Type": "application/json" } }
                );

                const result = response.data as {
                    responseCode: string;
                    responseMessage?: string;
                    responseData?: {
                        adSpaceData?: any[];
                        articleData?: ArticleData[]; // Typed response
                    };
                };

                if (result.responseCode === "00" && result.responseData) {

                    // A. Handle Banners
                    const homePageBanner = (result.responseData.adSpaceData || []).filter(
                        (ad: any) => ad.adPositionCode === "homePage-Banner"
                    );
                    setAdSpaceBanner(homePageBanner);

                    // B. Handle Articles
                    setArticleList(result.responseData.articleData || []);

                } else {
                    console.log("No data found in response");
                }
            } catch (error) {
                console.log("❌ Error fetching multiple data", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // 2. Fetch Vehicles (Existing logic)
    useEffect(() => {
        const fetchVehicles = async () => {
            // Optional: You might want a separate loading state for vehicles 
            // if you don't want the whole page to load at once, 
            // but for now, we share the loading state or let it run silently.
            try {
                const response = await axiosInstance.post(
                    "/CustomerVehicle/VehicleGetListPublished",
                    {},
                    { headers: { "Content-Type": "application/json" } }
                );

                const result = response.data as {
                    responseCode: string;
                    responseMessage?: string;
                    responseData?: { vehicleList?: any[] };
                };

                if (result.responseCode === "00" && result.responseData) {
                    setVehicles(result.responseData.vehicleList || []);
                } else {
                    console.log("No vehicles found");
                }
            } catch {
                console.log("❌ Error fetching vehicles");
            }
        };

        fetchVehicles();
    }, []);

    return (
        <>
            {/* Banner */}
            <BannerSection adSpaceBanner={adSpaceBanner} />

            {/* Article Section */}
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 1200,
                    mx: 'auto',
                    mt: -4,
                    position: 'relative',
                    zIndex: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {/* Pass the data and loading state props here */}
                <CommercialArticlesSection
                    articles={articleList}
                    isLoading={loading}
                />
            </Box>

            {/* Filters & Vehicles */}
            <Box sx={{ width: '100%', maxWidth: 1100, mx: 'auto', pb: 4 }}>
                {/* Only show if vehicles array has items */}
                {vehicles?.length > 0 && (
                    <VehicleExploreSection
                        title="Explore Our Vehicles"
                        navigateTo="/vehicle-listing"
                        vehicle={vehicles}
                    />
                )}
            </Box>

            <Footer />
        </>
    );
};

export default ArticlePage;